import { Box, Typography } from "@mui/material";
import ArticleIcon from "@mui/icons-material/Article";

// "פתיחת קריאה" title at the top of the form
const TicketFormHeader = () => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}>
    <ArticleIcon sx={{ color: "#2d3436" }} />
    <Typography
      variant="h6"
      sx={{
        fontSize: "1.125rem",
        fontWeight: 500,
        fontFamily: "Rubik, sans-serif",
        color: "#2d3436",
      }}
    >
      פתיחת קריאה
    </Typography>
  </Box>
);

export default TicketFormHeader;
